import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import navIcon1 from "../assets/img/nav-icon1.svg";
import github from "../assets/img/icons8-github-50.png";
import codepen from "../assets/img/codepen-logo-black.png";
import shadertoy from "../assets/img/shadertoy-logo.png";
import Sasuke from "../assets/img/port-photo.jpg";

import React, { useEffect, useState } from "react";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const openLinkInNewTab = (e) => {
    e.preventDefault();
    window.open(e.currentTarget.href, "_blank");
  };

  return (
    <Navbar expand="sm" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
          <img className="sasuke" src={Sasuke} alt="me" />
        </Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link
            href="#home"
            className={
              activeLink === "home" ? "active navbar-link" : "navbar-link"
            }
            onClick={() => onUpdateActiveLink("home")}
          >
            Home
          </Nav.Link>
          <Nav.Link
            href="#about"
            className={
              activeLink === "about" ? "active navbar-link" : "navbar-link"
            }
            onClick={() => onUpdateActiveLink("about")}
          >
            About
          </Nav.Link>
          <Nav.Link
            href="#projects"
            className={
              activeLink === "projects" ? "active navbar-link" : "navbar-link"
            }
            onClick={() => onUpdateActiveLink("projects")}
          >
            Projects
          </Nav.Link>
        </Nav>
        <span className="navbar-text">
          <div className="social-icon">
            <a
              onClick={openLinkInNewTab}
              href="https://www.linkedin.com/in/anthony-woodworth-532435261/"
            >
              <img src={navIcon1} alt="LinkedIn account" />
            </a>
          </div>
        </span>
        <span className="navbar-text">
          <div className="social-icon">
            <a
              onClick={openLinkInNewTab}
              href="https://github.com/Anthony-eng21"
            >
              <img src={github} alt="GitHub account" />
            </a>
          </div>
        </span>
        <span className="navbar-text">
          <div className="social-icon norm">
            <a
              onClick={openLinkInNewTab}
              href="https://www.shadertoy.com/user/woodtank554"
            >
              <img src={shadertoy} alt="ShaderToy account" />
            </a>
          </div>
        </span>
        <span className="navbar-text">
          <div className="social-icon">
            <a
              onClick={openLinkInNewTab}
              href="https://codepen.io/anthony-eng21"
            >
              <img src={codepen} alt="CodePen account" />
            </a>
          </div>
        </span>
        {/* </Navbar.Collapse> */}
      </Container>
    </Navbar>
  );
};
